module.exports = __webpack_public_path__ + "img/airplane-2.0de3d632.jpg";